import TagsListComponent from './TagList';

export default TagsListComponent;
